<template>
  <div class="about">
    <b-form-group
          horizontal
          :label-cols="4"
          description="Let us know your name."
          label="Enter your name"
        >
          <b-form-input v-model.trim="name"></b-form-input>
        </b-form-group>

        <b-alert variant="success" :show="showAlert">Hello {{ name }}</b-alert>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

export default {

  data() {
          return { name: '' }
        },
        computed: {
          showAlert() {
            return this.name.length > 4 ? true : false
          }
        }
}
</script>